export const INTRO_CHAT_TITLE =
  "Prueba GRATIS la corrección automática de tests y la descarga del informe en Word.";

export const INTRO_CHAT_TEXT =
  "Corrige protocolos de fonoaudiología, psicología o terapia ocupacional. Haz clic en Probar o en la vista previa.";

export const DEMO_OPEN_CHAT_TITLE =
  "Listo, elige profesión y test, completa el protocolo y descarga tu informe Word.";

export const DEMO_OPEN_CHAT_TEXT =
  "Puedes corregir varios tests de la misma sesión y descargar un informe integrado al final.";

// "Conocer más sobre el servicio" — the description every other product offers
// as a chat option. Kept as data (not an HTML blob) so it renders in the
// shell's own numbered-list style instead of carrying inline colors.
export const SERVICE_DETAILS_INTRO =
  "Corrige automáticamente los test estandarizados del Decreto 170 y obtén un informe profesional en Word.";

export const SERVICE_DETAILS_STEPS = [
  "Solo incorpora los puntajes del test y el informe se genera automáticamente, sin cálculos manuales.",
  "Obtienes un informe en Word listo para descargar y editar, con puntajes, índices y clasificaciones.",
  "Iniciando sesión puedes combinar más de un test de la misma profesión en un solo informe unificado.",
];

export const SERVICE_DETAILS_TESTS =
  "Corregimos test psicológicos, fonoaudiológicos y de terapia ocupacional: WISC-V, WAIS-IV, ICAP, CARAS-R, Conners, TEPROSIF-R, STSG, IDTEL, TECAL, Perfil Sensorial (cuestionario para padres, escolar y de adolescentes y adultos) y SPM-2.";

function formatSpanishList(names) {
  if (!names.length) return "";
  if (names.length === 1) return names[0];
  if (names.length === 2) return names[0] + " e " + names[1];
  return (
    names.slice(0, -1).join(", ") + " y " + names[names.length - 1]
  );
}

export function buildPostDownloadChat({ testLabel, pendingLabels, correctedCount, standalone = false }) {
  const title = "Excelente, ya tienes listo tu prueba " + testLabel + ".";
  let text = "Tu informe Word ya se descargó correctamente.";

  if (pendingLabels.length) {
    text +=
      " ¿Te gustaría revisar " +
      formatSpanishList(pendingLabels) +
      " y descargar un informe integrado con todos los tests corregidos? Elige otro test en el selector resaltado.";
  } else if (correctedCount > 1) {
    text =
      "Ya corregiste " +
      correctedCount +
      " tests en esta sesión. Puedes volver a descargar el informe integrado cuando quieras.";
  } else if (!standalone) {
    text +=
      " Cuando corrijas más tests de la misma profesión podrás unirlos en un solo informe.";
  }

  return { title, text, scroll: pendingLabels.length === 0 };
}
